module.exports = __webpack_public_path__ + "fonts/Cabin-700-latin12.810db45.woff2";